import { vuexfireMutations, firestoreAction } from "vuexfire";
import { db } from "@/plugins/db.js";

export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    assets: [],
    categories: [],
    units: []
  },

  mutations: {
    ...vuexfireMutations
  },
  actions: {
    bindAssets: firestoreAction(context => {
      return context.bindFirestoreRef("assets", db.collection("assets"));
    }),
    bindCategories: firestoreAction(context => {
      return context.bindFirestoreRef(
        "categories",
        db.collection("categories")
      );
    }),
    bindUnits: firestoreAction(context => {
      return context.bindFirestoreRef("units", db.collection("units"));
    })
  },
  getters: {}
};
